import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { POLICIES_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_POLICIES_LIST = '_LOAD_POLICIES_LIST';
export const CREATE_POLICIES = '_CREATE_POLICIES';
export const LOAD_POLICIES_BY_ID = '_LOAD_POLICIES_BY_ID';
export const EDIT_POLICIES_BY_ID = '_EDIT_POLICIES_BY_ID';
export const DELETE_POLICIES = '_DELETE_POLICIES';

export const loadPoliciesList = createDeferredAction(POLICIES_MODULE + LOAD_POLICIES_LIST);
export const loadPoliciesListBegin = createDeferredAction(POLICIES_MODULE + LOAD_POLICIES_LIST + BEGIN);
export const loadPoliciesListSuccessful = createAction(POLICIES_MODULE + LOAD_POLICIES_LIST + SUCCESSFUL);
export const loadPoliciesListFailed = createAction(POLICIES_MODULE + LOAD_POLICIES_LIST + FAILED);

export const createPolicies = createDeferredAction(POLICIES_MODULE + CREATE_POLICIES);
export const createPoliciesSuccessful = createAction(POLICIES_MODULE + CREATE_POLICIES + SUCCESSFUL);
export const createPoliciesFailed = createAction(POLICIES_MODULE + CREATE_POLICIES + FAILED);

export const loadPoliciesById = createDeferredAction(POLICIES_MODULE + LOAD_POLICIES_BY_ID);
export const loadPoliciesByIdSuccessful = createAction(POLICIES_MODULE + LOAD_POLICIES_BY_ID + SUCCESSFUL);
export const loadPoliciesByIdFailed = createAction(POLICIES_MODULE + LOAD_POLICIES_BY_ID + FAILED);
export const loadPoliciesByIdClear = createDeferredAction(POLICIES_MODULE + LOAD_POLICIES_BY_ID + CLEAR);

export const editPoliciesById = createDeferredAction(POLICIES_MODULE + EDIT_POLICIES_BY_ID);
export const editPoliciesByIdSuccessful = createAction(POLICIES_MODULE + EDIT_POLICIES_BY_ID + SUCCESSFUL);
export const editPoliciesByIdFailed = createAction(POLICIES_MODULE + EDIT_POLICIES_BY_ID + FAILED);

export const deletePolicies = createDeferredAction(POLICIES_MODULE + DELETE_POLICIES);
export const deletePoliciesSuccessful = createAction(POLICIES_MODULE + DELETE_POLICIES + SUCCESSFUL);
export const deletePoliciesFailed = createAction(POLICIES_MODULE + DELETE_POLICIES + FAILED);
